module.exports = __webpack_public_path__ + "img/05—Applications—Speed Test 03 > Internet Speed > Final State.aae778d0.jpg";